import { garconClient } from "@apis/axiosClients"

export const getEnergyImpact = async (callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/internal/agent_energy_impact_comparisons`,
    )
    callback(response.data)
  } catch (error) {
    console.error("Request error:", error)
  }
}

export const searchSalesAgents = async (agentQuery, callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/sales/agent/search?query=${agentQuery}`,
    )
    callback(response.data)
  } catch (error) {
    console.error("Request error:", error)
  }
}

export const getAgentRefundSummary = async (params, callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/cases/refunds/agent_summary`,
      { params },
    )
    callback(response.data)
  } catch (error) {
    console.error("Request error:", error)
  }
}
